export const iconFontAwesomeArrowsArrowRightLong = (
	<i className="fa-solid fa-arrow-right-long"></i>
);
